/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateOnboardingRequest
 */
export interface UpdateOnboardingRequest {
    /**
     * 
     */
    completed?: boolean;
    /**
     * 
     */
    dismissedSteps?: Set<UpdateOnboardingRequestDismissedStepsEnum>;
}


/**
 * @export
 */
export const UpdateOnboardingRequestDismissedStepsEnum = {
    Welcome: 'welcome',
    InviteTeam: 'invite-team',
    Modes: 'modes',
    CreateNfr: 'create-nfr',
    ConnectEntra: 'connect-entra',
    InstallCollector: 'install-collector',
} as const;
export type UpdateOnboardingRequestDismissedStepsEnum = typeof UpdateOnboardingRequestDismissedStepsEnum[keyof typeof UpdateOnboardingRequestDismissedStepsEnum];


/**
 * Check if a given object implements the UpdateOnboardingRequest interface.
 */
export function instanceOfUpdateOnboardingRequest(value: object): value is UpdateOnboardingRequest {
    return true;
}

export function UpdateOnboardingRequestFromJSON(json: any): UpdateOnboardingRequest {
    return UpdateOnboardingRequestFromJSONTyped(json, false);
}

export function UpdateOnboardingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOnboardingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'completed': json['completed'] == null ? undefined : json['completed'],
        'dismissedSteps': json['dismissedSteps'] == null ? undefined : new Set(json['dismissedSteps']),
    };
}

export function UpdateOnboardingRequestToJSON(json: any): UpdateOnboardingRequest {
    return UpdateOnboardingRequestToJSONTyped(json, false);
}

export function UpdateOnboardingRequestToJSONTyped(value?: UpdateOnboardingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'completed': value['completed'],
        'dismissedSteps': value['dismissedSteps'] == null ? undefined : Array.from(value['dismissedSteps'] as Set<any>),
    };
}

